module.exports = __webpack_public_path__ + "img/skinsosoft.341c18ee.jpg";